<script lang="ts" setup>
  import {onMounted, reactive, computed } from "vue";

  import BreadCrumb from "../../components/Common/BreadCrumb.vue";

  //servicos
  import * as service from "@/services/titularesService";

  //componentes
  import Paginador from "@/components/Paginador/Index.vue";
  import MsgBox from "@/components/MsgBox/Index.vue";
import { fdataHora } from "@/utils/funcoes";

  var controle = reactive({

    itens: [] as service.Titular[],


    status: "",
    erro: "",

    ordenacao: {
      coluna: '',
      asc: true
    },

    janVisualizar: false,
    itemVisualizar: null as service.Titular | null,
    linhasVisualizar: [] as string[][],
  })

  onMounted(async ()=>{
    
    pesquisar();
  })

  async function pesquisar() {

    service.obter()
    .then(r=> {
      controle.itens = r;
    })
    .catch(erro=> {
      controle.erro = erro;
    })
  }

  function ordenarPor(coluna: string) {
    if (controle.ordenacao.coluna === coluna) {
      controle.ordenacao.asc = !controle.ordenacao.asc;
    } else {
      controle.ordenacao.coluna = coluna;
      controle.ordenacao.asc = true;
    }
    controle.itens.sort((a, b) => {
      let valA = (a as Record<string, any>)[coluna];
      let valB = (b as Record<string, any>)[coluna];
      if (typeof valA === 'string') valA = valA.toLowerCase();
      if (typeof valB === 'string') valB = valB.toLowerCase();
      if (valA < valB) return controle.ordenacao.asc ? -1 : 1;
      if (valA > valB) return controle.ordenacao.asc ? 1 : -1;
      return 0;
    });
  }

    async function visualizar(item: service.Titular) {
      controle.erro = "";
      controle.itemVisualizar = item;
      controle.linhasVisualizar = [];
      controle.janVisualizar = true;

      service.obterPorId(item.id)
        .then(r => {
          const texto = r.conteudo || "";
          controle.linhasVisualizar = texto
            .split(/\r?\n/)
            .filter(linha => linha.trim() !== "")
            .map(linha => linha.split(";"));
        })
        .catch(erro => {
          controle.erro = erro;
          controle.janVisualizar = false;
        });
    }

    const cabecalhoVisualizar = computed(() => {
      if (controle.linhasVisualizar[0]?.length >= 5)
        return ["Nome", "Data Nascimento", "CPF", "ClienteId", "ContratoId"];
      return ["Nome", "Data Nascimento", "CPF"];
    });

    async function gerar() {

    service.gerar()
    .then(r=> {
      console.log(r);
      pesquisar();
    })
    .catch(erro=> {
      controle.erro = erro;
    })
  }
</script>

<template>
  <BreadCrumb PageTitle="Diário de Ativos" />

  <div class="card">
    <div class="card-body">
      <div class="row">

        <div class="col-md-12">
          <a class="btn btn-primary btn-sm mt-4 float-end" @click="gerar()"><i class="flaticon-play"></i> Gerar</a>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-md-12 table-responsive">
          <table class="table  align-middle mb-0 table-hover">
            <thead>
              <tr>
                <th @click="ordenarPor('usuarioId')" class="th-sortable">Id</th>
                <th @click="ordenarPor('nomeCompleto')" class="th-sortable">Data</th>
                <th @click="ordenarPor('tipoId')" class="th-sortable">Qtde</th>
                <th>Opções</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item,idx) in controle.itens" :key="idx" class="align-middle">
                <td>{{item.id}}</td>
                <td class="nowrap-celular">
                  {{fdataHora(item.dataGeracao)}}
                </td>
                <td>{{item.qtde}}</td>
                <td class="text-center text-nowrap">
                    <a class="" href="javascript:void(0);" title="Visualizar" @click="visualizar(item)">
                      <i  class="flaticon-view" ></i>
                    </a>
                    <a class="ms-2" href="javascript:void(0);" title="Baixar arquivo" @click="service.download(item.id)">
                      <i  class="flaticon-download-circular-button" ></i>
                    </a>
                </td>
              </tr>
            </tbody>
          </table>  
        </div>
      </div>
    </div>
    <div class="card-footer">
      <div class="row mt-2">
        <div class="col-md-6">
          {{ controle.itens.length }} Registros
        </div>
        <div class="col-md-4">
         
        </div>
        <div class="col-md-2">
          <RouterLink class="btn btn-secondary btn-sm  float-end" :to="'/'"><i class="flaticon-close"></i> Fechar</RouterLink>
        </div>
      </div>
    </div>
  </div>

  <MsgBox :id="'janVisualizar'" :titulo="'Diário de Ativos'" :tamanho="'modal-lg'" :exibir="controle.janVisualizar"
      @onFechou="controle.janVisualizar = false" :botao-fechar="true">
    <div class="row mb-2">
      <div class="col-md-12 fw-bold">
        {{ fdataHora(controle.itemVisualizar?.dataGeracao) }} — {{ controle.itemVisualizar?.qtde }} registro(s)
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 table-responsive" style="max-height: 60vh; overflow-y: auto;">
        <table class="table table-sm table-hover align-middle mb-0">
          <thead>
            <tr>
              <th v-for="(coluna, idx) in cabecalhoVisualizar" :key="idx">{{ coluna }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(linha, idx) in controle.linhasVisualizar" :key="idx">
              <td v-for="(valor, idx2) in linha" :key="idx2">{{ valor }}</td>
            </tr>
          </tbody>
        </table>
        <div v-if="!controle.linhasVisualizar.length" class="text-muted text-center py-4">
          Nenhum registro neste arquivo.
        </div>
      </div>
    </div>
  </MsgBox>
</template>

<style lang="css" scoped>


.th-sortable {
  cursor: pointer;
  user-select: none;
}

/* Evita quebra de linha nas colunas de nome/telefone apenas no celular */
@media (max-width: 767.98px) {
  .nowrap-celular {
    white-space: nowrap;
  }
}
</style>